import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { RequestOrigin } from './confirm-send-business-card.modal';

@Component({
  selector: 'planone-confirm-send-business-card',
  templateUrl: './confirm-send-business-card.component.html',
  styleUrl: './confirm-send-business-card.component.scss',
})
export class ConfirmSendBusinessCardComponent {
  private dialog = inject(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);
  isBauInsights = this.data.isBauInsights;
  origin: RequestOrigin = this.data.origin;

  onSendBusinessCard(): void {
    this.dialog.close(true);
  }
}
